// @ts-nocheck
import * as React from "react";

const EyeOffLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.29 3.29a1.004 1.004 0 0 1 1.42 0l16 16a1.002 1.002 0 0 1 0 1.42 1.002 1.002 0 0 1-1.42 0l-5.63-5.63a3.5 3.5 0 0 1-4.74-4.74L3.29 4.71l-.084-.095A1.004 1.004 0 0 1 3.29 3.29ZM5 7.87l1.46 1.41A13.7 13.7 0 0 0 4.22 12l.07.11c.952 1.482 3.737 4.988 7.93 4.89a7.74 7.74 0 0 0 1.7-.25l1.58 1.58a9.48 9.48 0 0 1-3.23.67h-.25c-5.89 0-9.26-5.41-9.89-6.5a1 1 0 0 1 0-1l.265-.443A15.89 15.89 0 0 1 5 7.87Zm7.078-2.874c5.76.04 9.165 5.416 9.792 6.504a1 1 0 0 1 .04 1l-.27.444A15.89 15.89 0 0 1 19 16.13l-1.51-1.41A13.7 13.7 0 0 0 19.78 12l-.07-.11c-.962-1.483-3.747-4.997-7.93-4.89a7.74 7.74 0 0 0-1.7.25L8.5 5.67A9.48 9.48 0 0 1 11.73 5ZM10.5 11.93V12l.007.144A1.5 1.5 0 0 0 12 13.5l.06-.01-1.56-1.56Z"
            />
        </svg>
    );
};

export default React.memo(EyeOffLine);
